import { EApplicantType, EFinancingProgram } from '@if/core/types'
import { ActionButton } from '@if/mui'
import { useResetBankAccountRequest } from '@src/data/api/credit-api/credit-api'
import { BankAccountRequestDto } from '@src/data/api/type'
import { useTranslation } from 'react-i18next'

interface Props {
  financingProgramId: EFinancingProgram
  applicantType: EApplicantType
  id: string
}

const ResetBankAccountButton = ({ applicantType, id, financingProgramId }: Props) => {
  const { t } = useTranslation()
  const [resetBankAccount, isResetingBankAccount] = useResetBankAccountRequest()

  const onResetBankAccount = async () => {
    const bankRequestDto = {
      applicantType,
      creditApplicationParams: { creditApplicationId: id, financingProgramId },
    } as BankAccountRequestDto
    await resetBankAccount(bankRequestDto)
  }

  return (
    <ActionButton fullWidth emphasis="principal" loading={isResetingBankAccount} onClick={onResetBankAccount}>
      {t('incomeVerification.resetBankAccount')}
    </ActionButton>
  )
}

export default ResetBankAccountButton
